import { makeStyles } from "@material-ui/styles";

export const useBillStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      //overflowX: "auto",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    table: {
      minWidth: 650,
    },
    commonButtonPosition: {
      paddingTop: "2.5em",
    },
    headingDescription: {
      fontWeight: "bold",
      fontSize: "1.10em",
    },
    footerCenterDescription: {
      paddingLeft: "0.5em",
      fontFamily: "Helvetica",
    },
    footerLeftDescription: {
      paddingLeft: "1.5em",
      fontFamily: "Helvetica",
    },
    footerRighDescription: {
      paddingLeft: "0.5em",
      paddingRight: "1.5em",
      fontFamily: "Helvetica",
    },
    logoImage: {
      height: "5em",
      width: "35em",
    },
    subTotalKeyStyle: {
      textAlign: "right",
    },
    subTotalValueStyle: {
      textAlign: "right",
      //paddingRight: "1.5em",
    },
    netTotalKeyStyle: {
      textAlign: "right",
      fontSize: "1.30em",
      fontWeight: "bold",
    },
    netTotalValueStyle: {
      textAlign: "right",
      fontSize: "1.30em",
      //paddingRight: "1.5em",
      fontWeight: "bold",
    },
    topSpacing: {
      paddingTop: "1em",
      //paddingLeft:"5em"
    },
    printDescription: {
      fontSize: "1.3rem",
      color: "black",
      fontWeight: "bolder",
    },
    billPaymentDeskStyle: {
      paddingTop: "1.5em",
      paddingBottom: "0.5em",
    },
    billInvoiceDetailsLeftDescriptionStyle: {
      textAlign: "left",
      paddingLeft: "1.60em",
      // fontWeight: "bold"
    },
    billInvoiceDetailsRightDescriptionStyle: {
      textAlign: "right",
      paddingRight: "1.60em",
      // fontWeight: "bold"
    },
    billInvoiceDetailsLeftKeyStyle: {
      textAlign: "left",
      paddingLeft: "1em",
      //fontWeight: "bold"
    },
    billInvoiceDetailsRightKeyStyle: {
      textAlign: "right",
      paddingRight: "1em",
      //fontWeight: "bold"
    },
    billInvoiceDetailsHeadingStyle: {
      textAlign: "right",
      paddingRight: "1em",
      paddingTop: "0.5em",
      fontSize: "1.5em",
      fontWeight: "bold",
      fontFamily: "Helvetica",
      color: "#2a3e52",
    },
    billInvoiceDetailsStoreNameStyle: {
      textAlign: "right",
      paddingRight: "1.60em",
      color: "#2a3e52",
      fontFamily: "Helvetica",
      fontSize: "1.10em",
      fontWeight: "bold",
    },
    QRCodeStyle: {
      textAlign: "right",
      paddingRight: "4em",
      // paddingTop: "1em"
    },
    billPaymentTypeStyle: {
      textAlign: "left",
      paddingLeft: "2em",
      fontFamily: "Helvetica",
      // fontSize: "1.15em",
      // fontWeight: "bold"
    },
    billPaymentValueStyle: {
      textAlign: "left",
      // fontWeight: "bold",
      fontFamily: "Helvetica",
      //fontSize: "1.15em"
    },
    footerCodeDescription: {
      paddingLeft: "0.5em",
      //fontWeight: "bold",
      paddingRight: "1.5em",
      fontSize: "1.20em",
      fontFamily: "Helvetica",
    },
    textFieldErrorMessageStyle: {
      textAlign: "left",
      paddingLeft: ".5em",
      paddingTop: ".5em",
      color: "red",
    },
    billItemListHeadStyle: {
      fontWeight: "bold",
      fontSize: "1.10em",
      color: "white",
      paddingLeft: ".5em",
      textAlign: "center",
      paddingBottom: "0.10em",
    },
    billItemDescriptionStyle: {
      paddingBottom: "0.3em",
      paddingTop: "0.3em",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalPaper: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: "15px",
      boxShadow: theme.shadows[2],
      padding: theme.spacing(2, 4, 3),
      maxHeight: "95vh",
      overflow: "auto",
    },
  })
);
